import React, { useState } from "react";
import { installmentCardLanguageOptions } from "./dropdown/dropdown-data";
import StatusUpdateModal from "../components/StatusUpdateModal";

const InstallmentCard = ({ datas = [], setUpdate, jwt, setOnReqConfirm }) => {
  console.log(datas); // Debugging check

  const [plans] = useState(datas || []);
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [filteredStatus, setFilteredStatus] = useState("ALL");

  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(null);

  // Function to show modal before updating status
  const toggleStatus = (index, status) => {
    const newStatus = status === "ACTIVE" ? "DISABLED" : "ACTIVE";

    // Create the confirmation message
    const message = `
      <b>${installmentCardLanguageOptions[jwt]?.messages[0]}: </b> ${status} <br><br>
      <b>${installmentCardLanguageOptions[jwt]?.messages[1]} :</b> ${newStatus} <br><br>
    `;

    setConfirmMessage(message);
    setSelectedPlan({ id: index, newStatus });
    setIsModalOpen(true);
    setUpdate({
      id: index,
      status: status === "ACTIVE" ? "DISABLED" : "ACTIVE",
    });
  };

  // Function to update status on confirm
  const handleConfirm = () => {
    if (selectedPlan) {
      setOnReqConfirm("true");
    }
    setIsModalOpen(false);
  };

  // Function to cancel update
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const toggleCollapse = (index) => {
    setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const filteredInstallments = (installments) =>
    Array.isArray(installments)
      ? filteredStatus === "ALL"
        ? installments
        : installments.filter(
            (installment) => installment.installmentStatus === filteredStatus
          )
      : [];

  return (
    <div className="max-w-md mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
      {plans.length > 0 ? (
        plans.map((data, index) => (
          <div key={index} className="p-6">
            <h2 className="text-xl font-semibold text-[#808080] mb-4">
              {installmentCardLanguageOptions[jwt].labels?.[0]}
            </h2>
            <div className="mb-4">
              <div className="flex justify-between">
                <span className="text-gray-500">
                  {installmentCardLanguageOptions[jwt].labels?.[1]}:
                </span>
                <span className="text-gray-800">{data.accountNo}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-500">
                  {installmentCardLanguageOptions[jwt].labels?.[2]}:
                </span>
                <span className="text-gray-800">{data.amount?.toFixed(2)}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-500">
                  {installmentCardLanguageOptions[jwt].labels?.[3]}:
                </span>
                <span className="text-gray-800">{data.scheduleFrequency}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-500">
                  {installmentCardLanguageOptions[jwt].labels?.[4]}:
                </span>
                <span className="text-gray-800">{data.frequency}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-500">
                  {installmentCardLanguageOptions[jwt].labels?.[5]}:
                </span>
                <span
                  className={`text-gray-800 ${
                    data.status === "ACTIVE" ? "text-green-500" : "text-red-500"
                  }`}
                >
                  {data.status}
                </span>
              </div>
            </div>
            <div className="flex justify-between">
              <button
                className={`px-4 py-2 text-white rounded ${
                  data.status === "ACTIVE" ? "bg-red-500" : "bg-green-500"
                }`}
                onClick={() => toggleStatus(data.id, data.status)}
              >
                {data.status === "ACTIVE"
                  ? `${installmentCardLanguageOptions[jwt].status[0]}`
                  : `${installmentCardLanguageOptions[jwt].status[1]}`}
              </button>
              <button
                className=" px-4 py-2 text-white bg-blue-500 rounded"
                onClick={() => toggleCollapse(index)}
              >
                {expandedIndex === index
                  ? installmentCardLanguageOptions[jwt].toggle?.[0]
                  : installmentCardLanguageOptions[jwt].toggle?.[1]}
              </button>
            </div>

            {/* Expandable Section */}
            {expandedIndex === index && (
              <div className="">
                <div className="mt-4 py-2 flex space-x-4">
                  {["ALL", "PENDING", "TRANSFERRED", "FAILED"].map(
                    (status, idx) => (
                      <button
                        key={idx}
                        className={`px-1 text-base py-2 rounded ${
                          filteredStatus === status
                            ? "bg-blue-500 text-white"
                            : "bg-gray-200"
                        }`}
                        onClick={() => setFilteredStatus(status)}
                      >
                        {installmentCardLanguageOptions[jwt].tabs?.[idx] ||
                          status}
                      </button>
                    )
                  )}
                </div>

                {/* Installments List */}
                {filteredInstallments(data.installments).length > 0 ? (
                  filteredInstallments(data.installments).map(
                    (installment, installmentIndex) => (
                      <div
                        key={installmentIndex}
                        className="mb-4 border-t border-gray-200 pt-4 shadow-lg py-1 px-2"
                      >
                        <div className="flex justify-between">
                          <span className="text-gray-500">
                            {installmentCardLanguageOptions[jwt].labels?.[6]}:
                          </span>
                          <span className="text-gray-800">
                            {installment.installmentDate &&
                              new Date(
                                installment.installmentDate
                              ).toLocaleDateString()}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-500">
                            {installmentCardLanguageOptions[jwt].labels?.[7]}:
                          </span>
                          <span className="text-gray-800">
                            {installment.amount &&
                              installment.amount.toFixed(2)}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-500">
                            {installmentCardLanguageOptions[jwt].labels?.[8]}:
                          </span>
                          <span
                            className={`text-gray-800 ${
                              installment.installmentStatus === "FAILED"
                                ? "text-red-500"
                                : "text-green-500"
                            }`}
                          >
                            {installment.installmentStatus}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-gray-500">
                            {installmentCardLanguageOptions[jwt].labels?.[9]}:
                          </span>
                          <span className="text-gray-800 line-clamp-3">
                            {installment.reason}
                          </span>
                        </div>
                      </div>
                    )
                  )
                ) : (
                  <p className="text-gray-500 mt-4">
                    {installmentCardLanguageOptions[jwt].Error[0]}
                  </p>
                )}
              </div>
            )}
          </div>
        ))
      ) : (
        <p className="text-center p-4">
          {installmentCardLanguageOptions[jwt].Error[1]}
        </p>
      )}
      {/* Status Update Modal */}
      {isModalOpen && (
        <StatusUpdateModal
          message={confirmMessage}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          jwt={jwt}
        />
      )}
    </div>
  );
};

export default InstallmentCard;
